import React, { useState } from 'react'
import miniatura from '../Imagenes/VelocitySurgeon.png'
import rana from '../Imagenes/3HourJam.png'

export const GameJams = () => {
    const imagen = [miniatura, rana]

    const [displayState, setDisplayStates] = useState({
        speedJam4: 'block',
        OneHourJam: 'Block'
    });

    const toggleDisplay = (name) => {
        setDisplayStates(prevState => ({
            ...prevState,
            [name]: prevState[name] === 'block' ? 'none' : 'block'
        }));
    };

    return (
    <>
        <div className='banner'>
            <div className='fondo-banner'></div>
            <h1>Game Jams</h1>
        </div>
        <div className='appear'>
        
        <p className='opaco contenido'>11/3/2024</p>
        <h2 onClick={() => toggleDisplay('OneHourJam')}>
            <b>3 Hours Jam: </b><em>Rana Insana</em>
            <span class="material-symbols-outlined fixV derecha">arrow_drop_down</span>
        </h2>
        <section className='card card-bottom cfondo expand' style={{ display: displayState.OneHourJam }}>
            <div className='dividir'>
                <a rel="noreferrer" target='_blank' href='https://ghoko.itch.io/velocity-surge' className='centrar'><img alt='Logo de Rana insana' className='miniatura' src={imagen[1]}></img></a>
                <div>
                    <div>
                        <p>Para una competencia no profesional, <a rel="noreferrer" target='_blank' href='https://ghoko.itch.io/'>Ghoko</a> y yo, decidimos competir por quien hacia el mejor juego en un laptso total de 3 Horas, <b>"La rana insana"</b> fue mi juego hecho en Godot Engine para esta competencia, fue 100% hecho por mi.</p>
                    </div>
                    <div className='FondoOscuro'>
                        <a href='https://drive.google.com/uc?export=download&id=1V6jIGSXlmEYXTJ4KpGlZ9s1lvYOLiUtQ' download className='boton derecha' ><span className="material-symbols-outlined fixV">download</span><span className='dis'> Descargar Juego </span><span class="fixV material-symbols-outlined">desktop_windows</span></a>
                    </div>
                </div>
            </div>
        </section>

        <br/>

        <p className='opaco contenido'>09/3/2024</p>
        <h2 onClick={() => toggleDisplay('speedJam4')}>
            <b>SpeedJam4: </b><em>Velocity Surgeon</em>
            <span class="material-symbols-outlined fixV derecha">arrow_drop_down</span>
        </h2>
        <section className='card card-bottom cfondo expand' style={{ display: displayState.speedJam4 }}>
            <div className='dividir'>
                <a rel="noreferrer" target='_blank' href='https://ghoko.itch.io/velocity-surge' className='centrar'><img alt='Logo de Velocity Surgeon' className='miniatura' src={imagen[0]}></img></a>
                <div>
                    <div>
                        <p>Hecho con <a rel="noreferrer" target='_blank' href='https://ghoko.itch.io/'>Ghoko</a> en Godot Engine, fue nuestra primera participacion en una Game Jam <a rel="noreferrer" target='_blank' href='https://itch.io/jam/speedjam4'>"SpeedJam4"</a> de itchio, publicado el <em>09 de marzo del 2024</em>.
                        <br/>
                        <h3>Equipo de desarrollo:</h3>
                        <ul>
                            <li>Cro128 <span className='opaco'>(Dev)</span></li>
                            <li>Ghoko <span className='opaco'>(Dev)</span></li>
                            <li>Koshi <span className='opaco'>(Artista)</span></li>
                            <li>LaurPink <span className='opaco'>(Artista)</span></li>
                        </ul>
                        <br/>
                        </p>
                    </div>
                    <div className='FondoOscuro'>
                        <a rel="noreferrer" target='_blank' href='https://ghoko.itch.io/velocity-surge' className='boton derecha' ><span className="material-symbols-outlined fixV">download</span><span className='dis'> Descargar Juego </span><span class="fixV material-symbols-outlined">desktop_windows</span></a>
                    </div>
                </div>
            </div>
        </section>
        </div>
    </>
    )
}